module.exports = __webpack_public_path__ + "static/media/Cal-the-Musical-Checking-the-Phone.80ea5b96.jpg";